// eslint-disable-next-line import/no-extraneous-dependencies
import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#00447C',
        secondary: '#00ACE6',
        accent: '#EFEFEF',
        error: '#FF5252',
        info: '#616060',
        success: '#4CAF50',
        warning: '#FFDC00',
        primary1: '#00ACE6',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
